import { render, staticRenderFns } from "./WarrantyItems.vue?vue&type=template&id=11aefd12&"
import script from "./WarrantyItems.vue?vue&type=script&lang=js&"
export * from "./WarrantyItems.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports